import { Subject } from 'rxjs/Subject';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertService } from 'sce-core';
import { SearchService } from '../../../../../shared/search/search.service';
import { ConfirmDialogService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { ButtonItem } from '../../../../../shared/button/button.model';
import { SearchParams } from '../../../../../shared/search/models/search-params.model';
import { DataTableConfig } from '../../../../../shared/search/models/data-table-config';
import { SearchStatus } from '../../../../../shared/search/models/search-status.model';
import { SearchEvent } from '../../../../../shared/search/models/search-event';
import { ITEM_CLICK_EVENT, NEW_SEARCH_EVENT } from '../../../../../shared/search/search-constants';
import { SearchCriteria, Condition, Clause } from '../../../../../shared/search/models/search-filter-model';
import { DataTableEditorService } from '../../../../../shared/search/results/data-table-editor.service';
import { ModalService } from '../../../../../shared/services/modal.service';
import { WAVE_CONTROL } from '../../../outbound-constants';

@Component({
  selector: 'lfwms-generate-loadplan-popup',
  templateUrl: './generate-loadplan-popup.component.html',
  styleUrls: ['./generate-loadplan-popup.component.css']
})
export class GenerateLoadplanPopupComponent implements OnDestroy {

  public lookupAlertService: AlertService;

  public lookupSearchService: SearchService;
  public confirmDialogService: ConfirmDialogService;
  public resourceService: ResourceService;
  /* Eventhough this variable is not needed here
   as it is provided in the action service where the popup is called,
    this variable must be provided to avoid --aot error*/
  public title: string;
  private callbackFunction: any;
  private parentRef: any;
  public parentDataService: any;
  public dataEditor: any;
  public isLoading: boolean = true;
  public noOfOrders: string;
  public buildType: string;
  public footerDetails: string = '';

  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {
    this.lookupAlertService = new AlertService();
    this.confirmDialogService = new ConfirmDialogService();
    this.resourceService = this.coreServiceRegistry.resourceService;
  }

  public registerCallback(callback: any, parentRef: any) {
    this.callbackFunction = callback;
    this.parentRef = parentRef;
  }

  public initializeComponents(dataService, noOfOrders, type) {
    /* Data editor is needed  for searching in tableheader filter */
    this.parentDataService = dataService;
    this.noOfOrders = noOfOrders;
    this.buildType = type;
    if (WAVE_CONTROL.GENERATE_LOAD_PLAN === type) {
      this.footerDetails = `${this.resourceService.get('lbl_no_of_order_not_in_load')}: ${this.noOfOrders}`;
    } else {
      this.footerDetails = `${this.resourceService.get('lbl_no_of_order_not_in_ship')}: ${this.noOfOrders}`;
    }
    this.lookupSearchService = this.createSearchService('wcbuildparmtd');
    const searchCriteria = this.createSearchCriteria(type);
    const tableEditor: DataTableEditorService = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    this.dataEditor = tableEditor;
    this.lookupSearchService.searchParams.tableEditor = tableEditor;
    this.lookupSearchService.setSearchCriteria(searchCriteria);
    this.lookupSearchService.fetchMetadata()
      .subscribe(() => {
        this.lookupSearchService.setSearchCriteria(searchCriteria);
        this.lookupSearchService.performSearch();
        this.isLoading = false;
      });
  }

  public createSearchCriteria(type:string) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createDefaultSearchCondition(1);
    defaultCondition1.isReadOnly = true;
    defaultCondition1.isMandatory = true;
    defaultCondition1.operator = 'AND';
    const defaultClause1 = new Clause();
    defaultClause1.column = 'storerKey';
    defaultClause1.value = this.parentDataService.waveInfoSearchService.pagedData.pageRows[0].cells['storerKey'].cVal;
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = 'AND';
    const defaultClause2 = new Clause();
    defaultClause2.column = 'facility';
    defaultClause2.value = this.parentDataService.waveInfoSearchService.pagedData.pageRows[0].cells['facility'].cVal;
    defaultClause2.operation = '=';
    defaultClause2.logicalOperation = 'AND';
    const defaultClause3 = new Clause();
    defaultClause3.column = WAVE_CONTROL.TYPE;
    defaultClause3.value = type;
    defaultClause3.operation = WAVE_CONTROL.OPERATIONS.EQUAL;
    defaultClause3.logicalOperation = WAVE_CONTROL.OPERATIONS.AND;
    defaultCondition1.clauses = [defaultClause1, defaultClause2, defaultClause3];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }
  protected createDefaultSearchCondition(id) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }


  private createSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    searchParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.lookupAlertService;
    searchParams.tableEditor = this.dataEditor;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    searchParams.idProperty = 'buildparmkey';
    return searchService;
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public generateLoadPlan() {
    if (this.callbackFunction) {
      const noOfLineItems = this.lookupSearchService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        // No details available to proceed the action
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const selectedLineItems: any = this.lookupSearchService.getSelectedRows();
      if (selectedLineItems.length === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_sel_detail'));
        return;
      }
      const buildParmKeyList: Array<any> = [];
      for (let j = 0; j < selectedLineItems.length; j++) {
        buildParmKeyList.push(selectedLineItems[j].cells['buildparmkey'].cVal);
      }

      const generateRequest: any = {
        'waveKey': this.parentDataService.waveIdValue,
        'popupWindow': '1',
        'buildparamKeys': buildParmKeyList
      };
      this.callbackFunction(this.parentRef, generateRequest, this.buildType);
    }
  }

  public formatSearchCriteria(searchCriteria) {
    if (!searchCriteria) {
      return {};
    }
    let allConditions = null;
    // Code added to merge filter conditions with master search criteria, if filter condition is there.
    allConditions = searchCriteria.conditions;

    const conditionReqList = [];
    allConditions.forEach((condition: any, index: any) => {
      const clauseReqlist = [];
      condition.clauses.forEach((clause: any) => {
        if (clause.value !== undefined && clause.value !== null) {
          clauseReqlist.push({
            column: clause.column,
            operation: clause.operation,
            value: clause.value,
            value1: clause.value1,
            logicalOperation: clause.logicalOperation
          });
        }
      });
      if (clauseReqlist.length !== 0) {
        let logOp = null;
        if (index < allConditions.length - 1) {
          logOp = condition.operator;
        }
        conditionReqList.push({
          mandatory: condition.isMandatory,
          clauses: clauseReqlist,
          logicalOperation: logOp
        });
      }
    });
    return { conditions: conditionReqList };
  }

  public ngOnDestroy() {
    // Memory Cleanup
    this.lookupSearchService = null;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/wave-summary/wave-summary-home/generate-loadplan-popup/generate-loadplan-popup.component.ts